/**
 * @generated SignedSource<<373be9c54c74858b001dfff1e7f9ab7d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ActivateJiraServerInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type activateJiraServerMutation$variables = {
  input: ActivateJiraServerInput;
};
export type activateJiraServerMutation$data = {
  readonly activateJiraServer: {
    readonly company: {
      readonly jiraServerConsumerKey: string | null;
      readonly jiraServerPublicRsaKey: string | null;
      readonly jiraServerState: string | null;
    } | null;
  } | null;
};
export type activateJiraServerMutation = {
  variables: activateJiraServerMutation$variables;
  response: activateJiraServerMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraServerConsumerKey",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraServerPublicRsaKey",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraServerState",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "activateJiraServerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ActivateJiraServerPayload",
        "kind": "LinkedField",
        "name": "activateJiraServer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "activateJiraServerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ActivateJiraServerPayload",
        "kind": "LinkedField",
        "name": "activateJiraServer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c8b763c1a7c86eda07caa39892b09f69",
    "id": null,
    "metadata": {},
    "name": "activateJiraServerMutation",
    "operationKind": "mutation",
    "text": "mutation activateJiraServerMutation(\n  $input: ActivateJiraServerInput!\n) {\n  activateJiraServer(input: $input) {\n    company {\n      jiraServerConsumerKey\n      jiraServerPublicRsaKey\n      jiraServerState\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4f2ff7c44a483956ed26e04245244453";

export default node;
